import { render } from "./Activation.vue?vue&type=template&id=6c4a44de&scoped=true&ts=true"
import script from "./Activation.vue?vue&type=script&lang=ts"
export * from "./Activation.vue?vue&type=script&lang=ts"

import "./Activation.vue?vue&type=style&index=0&id=6c4a44de&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4a44de"]])

export default __exports__